// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"HeroProject_sectionHeading__WhMk0"};